<template>
  <nav id="Navbar" class="border-b border-gray-100">
    <div class="md:px-4 px-14 md:py-4 py-6 shadow">
      <div class="continer mx-auto flex items-center justify-between">
        <!-- Left section -->
        <ul class="flex items-center">
          <li><img class="h-4 md:h-6" src="/img/logo.svg" alt="logo" /></li>
        </ul>

        <!-- Right section -->
        <ul class="flex md:hidden items-center">
          <li class="mr-8">
            <router-link to="/" 
                class="
                text-gray-600
                font-semibold
                hover:text-red-500
                active:text-red-700">Home
            </router-link>
          </li>

          <li class="mr-8">
            <router-link to="/about" 
                class="
                text-gray-600
                font-semibold
                hover:text-red-500
                active:text-red-700">About
                </router-link>
          </li>
          <li class="mr-8">
            <router-link to="/contact-us" class="
                text-gray-600
                font-semibold
                hover:text-red-500
                active:text-red-700">Contact-Us
            </router-link>    
          </li>
          <li class="mr-4">
            <router-link to="/Signin" 
                class="
                align-middle
                py-2
                px-4
                border border-gray-400
                bg-white
                hover:bg-red-500
                hover:text-white
                text-gray-800
                font-semibold
                py-2
                px-4
                border border-gray-400
                rounded
                shadow">Login
            </router-link> 
          </li>
          <li>
            <router-link to="/CreateAccount" 
              class="
                py-2
                px-4
                border border-gray-400
                bg-red-500
                text-white
                hover:bg-red-600
                hover:text-white
                font-semibold
                py-2
                px-4
                border border-gray-400
                rounded
                shadow">Register
              </router-link>
          </li>
        </ul>

        <ul class=" hidden md:block" id="bugger" v-on:click="isOpen = !isOpen">
          <li>
            <button class="mobile-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </li>
        </ul>
      </div>
      <!-- MOBILE MENU -->
      <div class="mobile_menu">
        <ul class="hidden md:block mt-4" id="navMenu" v-if="isOpen">
          <li>
            <router-link to="/" 
              class="
                block
                py-2
                px-2
                text-gray-600
                font-semibold
                hover:text-red-500
                active:text-red-700">Home
             </router-link>
            </li>

             <li>
            <router-link to="/about" 
              class="
                block
                py-2
                px-2
                text-gray-600
                font-semibold
                hover:text-red-500
                active:text-red-700">About
             </router-link>
            </li>

             <li>
            <router-link to="/contact-us" 
              class="
                block
                py-2
                px-2
                text-gray-600
                font-semibold
                hover:text-red-500
                active:text-red-700">Contact-Us
             </router-link>
            </li>
            <div class="flex flex-row items-center mt-4 ">
              <router-link to="/Signin" 
                class="
                align-middle
                py-2
                px-4
                border border-gray-400
                bg-white
                hover:bg-red-500
                hover:text-white
                text-gray-800
                font-semibold
                py-2
                px-4
                border border-gray-400
                rounded
                shadow">Login
            </router-link> 
            <router-link to="/CreateAccount"
             class="
                py-2
                px-4 ml-4
                border border-red-400
                bg-red-500
                text-white
                hover:bg-red-600
                hover:text-white
                font-semibold
                py-2
                px-4
                border border-gray-400
                rounded
                shadow">Register
              </router-link>
            </div>
           
         
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Logo from "./Logo.vue";
export default {
  name: "Navbar",
  Logo,

  data() {
    return { isOpen: false };
  },
};
</script>